import React, { Component } from 'react'
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import { KTColors } from '../Constants/KTColors'
import html2canvas from 'html2canvas'
import KTColorPicker from '../Constants/KTColorPicker'
import MDEditor from '@uiw/react-md-editor'
import getImageTemplatesService from '../../Services/Queries/getImageTemplatesService'

class ImageTemplate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedImageTemplateType: 'story',
      colorPicker: false,
      textColor: KTColors.white,
      descPositionFromTop: '15',
      descFontSize: '2.6',
      textFontWeight: true,
      textCenter: true,
      storyTemplates: [],
      coverStoryTemplates: [],
    }
  }

  changeType = (type) => {
    this.setState({ selectedImageTemplateType: type })
  }

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader()
      reader.addEventListener('load', () => this.setState({ src: reader.result }))
      reader.readAsDataURL(e.target.files[0])
    }
  }

  PrintDiv = (templateTitle) => {
    html2canvas(document.getElementById('generateTemplateImage'), {
      useCORS: true,
    }).then(function(canvas) {
      var imageURL = canvas.toDataURL('image/png')
      let a = document.createElement('a')
      a.href = imageURL
      a.download = templateTitle
      a.click()
    })
  }

  renderTemplate = () => {
    return (
      <div class='col-md-12'>
        <div class='row col-md-8' style={{ marginTop: 5 }}>
          <text style={{ fontWeight: 'bold' }}>Image Templates :</text>
        </div>
        {this.state.selectedImageTemplateType == 'story' ? (
          <div>
            {this.state.storyTemplates.map((img) => {
              return (
                <span
                  onClick={() => this.setState({ src: img.imageTemplatePath })}
                  style={{ marginRight: 5 }}
                >
                  <img
                    src={img.imageTemplatePath}
                    alt='img_template'
                    style={{
                      height: heightPercentageToDP('10'),
                      width: widthPercentageToDP('20'),
                    }}
                  />
                </span>
              )
            })}
          </div>
        ) : (
          <div>
            {this.state.coverStoryTemplates.map((img) => {
              return (
                <span
                  onClick={() => this.setState({ src: img.imageTemplatePath })}
                  style={{ marginRight: 5 }}
                >
                  <img
                    src={img.imageTemplatePath}
                    alt='img_template'
                    style={{
                      height: heightPercentageToDP('10'),
                      width: widthPercentageToDP('20'),
                    }}
                  />
                </span>
              )
            })}
          </div>
        )}
        <div class='row col-md-8' style={{ marginTop: 5 }}>
          <text style={{ fontWeight: 'bold' }}>Image :</text>
          <input type='file' accept='image/*' onChange={this.onSelectFile} />
        </div>
        <div class='row col-md-8' style={{ marginTop: 5 }}>
          <text style={{ fontWeight: 'bold' }}>Description :</text>
          <div class='row col-md-12' style={{ marginLeft: 5 }}>
            <textarea
              type='text'
              onChange={(e) => {
                this.setState({ description: e.target.value })
              }}
              value={this.state.description}
              placeholder='Please Enter Description'
            ></textarea>
          </div>
        </div>
        <div style={{ marginTop: 5 }}>
          <input
            type='checkbox'
            onChange={() => this.setState({ textCenter: !this.state.textCenter })}
            checked={this.state.textCenter}
          ></input>
          <text>Center Text</text>
        </div>
        <div style={{ marginTop: 5 }}>
          <input
            type='checkbox'
            onChange={() => this.setState({ boldEnabled: !this.state.boldEnabled })}
            checked={this.state.boldEnabled}
          ></input>
          <text>Bold Description </text>
        </div>
        <div class='row col-md-9' style={{ marginTop: 5 }}>
          <text style={{ fontWeight: 'bold' }}>Description Position From Top :</text>
          <div class='row col-md-9' style={{ marginLeft: 5 }}>
            <input
              type='number'
              onChange={(e) => {
                this.setState({ descPositionFromTop: e.target.value })
              }}
              value={this.state.descPositionFromTop}
              placeholder='Please Enter color (#XXXXXX)'
            ></input>
          </div>
        </div>
        <div class='row col-md-9' style={{ marginTop: 5 }}>
          <text style={{ fontWeight: 'bold' }}>Description FontSize :</text>
          <div class='row col-md-9' style={{ marginLeft: 5 }}>
            <input
              type='number'
              onChange={(e) => {
                this.setState({ descFontSize: e.target.value })
              }}
              value={this.state.descFontSize}
              placeholder='Please Enter color (#XXXXXX)'
            ></input>
          </div>
        </div>
        <div class='row col-md-9' style={{ marginTop: 5 }}>
          <text style={{ fontWeight: 'bold' }}>Description Color :</text>
          <div class='row col-md-9' style={{ marginLeft: 5 }}>
            <input
              type='text'
              onChange={(e) => {
                this.setState({ textColor: e.target.value })
              }}
              value={this.state.textColor}
              placeholder='Please Enter color (#XXXXXX)'
            ></input>
          </div>
        </div>
        <div style={{ marginTop: 5 }}>
          <input
            type='checkbox'
            onChange={() => this.setState({ colorPicker: !this.state.colorPicker })}
            checked={this.state.colorPicker}
            placeholder='Color picker'
          ></input>
          <text>{'Color picker'}</text>
        </div>
        {this.state.colorPicker && (
          <div style={{ marginTop: 10, marginBottom: 10 }}>
            <KTColorPicker />
          </div>
        )}
        <div style={{ marginTop: 10 }}>
          <button
            onClick={() => {
              this.PrintDiv(this.state.description)
            }}
          >
            Download Template Thumbnail
          </button>
        </div>
        <div>
          <text style={{ fontSize: heightPercentageToDP('1.4') }}>
            *If any issues with Template download, please try with Firefox browser.
          </text>
        </div>
      </div>
    )
  }

  async componentDidMount() {
    const storyTemplates = await getImageTemplatesService({
      limit: 10,
      imageTemplateContentType: 'Story',
    })
    const coverStoryTemplates = await getImageTemplatesService({
      limit: 10,
      imageTemplateContentType: 'CoverStory',
    })
    this.setState({
      storyTemplates,
      coverStoryTemplates,
    })
  }

  render() {
    const { selectedImageTemplateType } = this.state
    const imgHeight = selectedImageTemplateType == 'coverStory' ? '100' : '35'
    const textFontWeight = this.state.boldEnabled ? 'bold' : 'normal'
    const textAlignCenter = this.state.textCenter ? 'center' : 'left'
    return (
      <div class=' row col-md-12'>
        <div
          class='col-md-7'
          style={{
            borderWidth: 2,
            borderColor: KTColors.black,
            borderStyle: 'solid',
          }}
        >
          <text style={{ fontWeight: 'bold' }}>{'Select Type'}</text>
          <div class='col-md-6'>
            <input
              value={'Story'}
              type='radio'
              checked={selectedImageTemplateType == 'story'}
              onChange={() => {
                this.changeType('story')
              }}
            ></input>
            <text for={'Story'}>{' Story'}</text>
          </div>
          <div class='col-md-3'>
            <input
              value={'Cover story'}
              type='radio'
              checked={selectedImageTemplateType == 'coverStory'}
              onChange={() => {
                this.changeType('coverStory')
              }}
            ></input>
            <text for={'Story'}>{' Cover story'}</text>
          </div>
          <div class='col-md-3'>
            <input
              value={'Meme'}
              type='radio'
              checked={selectedImageTemplateType == 'meme'}
              onChange={() => {
                this.changeType('meme')
              }}
            ></input>
            <text for={'Story'}>{'Meme'}</text>
          </div>
          {this.renderTemplate()}
        </div>
        <div class='col-md-1'></div>
        <div class='col-md-4'>
          {this.state.src ? (
            <div>
              <div
                style={{
                  height: heightPercentageToDP(imgHeight),
                  width: widthPercentageToDP('100%'),
                  position: 'relative',
                }}
                id='generateTemplateImage'
              >
                <div
                  style={{
                    position: 'absolute',
                    top: heightPercentageToDP(this.state.descPositionFromTop),
                    padding: widthPercentageToDP('10%'),
                    paddingLeft: widthPercentageToDP('8%'),
                    width: widthPercentageToDP('100'),
                    textAlign: textAlignCenter,
                  }}
                >
                  <MDEditor.Markdown
                    style={{
                      fontSize: heightPercentageToDP(this.state.descFontSize),
                      color: this.state.textColor,
                      flexWrap: 'wrap',
                      fontWeight: textFontWeight,
                    }}
                    source={this.state.description}
                  />
                </div>
                <img
                  src={this.state.src}
                  alt='User Avatar'
                  style={{
                    height: heightPercentageToDP(imgHeight),
                    width: widthPercentageToDP('100.1'),
                  }}
                />
              </div>
            </div>
          ) : (
            <div
              style={{
                marginTop: heightPercentageToDP('15'),
                textAlign: 'center',
              }}
            >
              <text style={{ fontWeight: 'bold' }}>Preview here</text>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default ImageTemplate
